import { gql } from "@apollo/client";

const UPDATE_METAFIELD = gql`
  mutation updateMetafield($input: MetaField) {
    updateMetafield(input: $input) {
      data
      status
      error
    }
  }
`;
export default UPDATE_METAFIELD;
